import styled from '@emotion/styled';

export const Content = styled.div`
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
        margin: 0 0 1em;

        /* :first-child {
            margin: 0 0 1em;
        }

        :last-child {
            margin: 0;
        } */
    }

    li:not(last-of-type) {
        margin: 0 0 1em;
    }

    img {
        max-width: 100%;
    }
`;
